import { defineMessages } from 'react-intl';

export default defineMessages({
  integrationNotFound: {
    id: 'app.containers.Integrations.integrationNotFound',
    defaultMessage:
      'Integration not configured. Please ask your {integration} admin to enable it.',
  },
  integrationNotConfigured: {
    id: 'app.containers.Integrations.integrationNotConfigured',
    defaultMessage: 'Integration not configured. Go to settings and enable it.',
  },

  buttonSettings: {
    id: 'app.containers.Integrations.buttonSettings',
    defaultMessage: 'Settings',
  },

  refreshPromptTitle: {
    id: 'app.containers.Integrations.refreshPromptTitle',
    defaultMessage: 'Please refresh the page',
  },
  refreshPromptDescription: {
    id: 'app.containers.Integrations.refreshPromptDescription',
    defaultMessage:
      'Please refresh the page by clicking on the **Refresh** icon in the upper right corner.',
  },
  createSubmissionSuccess: {
    id: 'app.containers.Integrations.createSubmissionSuccess',
    defaultMessage: 'Candidate was successfully submitted to a job',
  },
  createBulkSubmissionProcessing: {
    id: 'app.containers.Integrations.createBulkSubmissionProcessing',
    defaultMessage:
      'Candidates are being submitted to the job. This may take a few minutes to complete.',
  },
  addCandidateToTearsheetSuccess: {
    id: 'app.containers.Integrations.addCandidateToTearsheetSuccess',
    defaultMessage: 'Candidate(s) was successfully added to the tearsheet(s)',
  },
  addCandidateToTearsheetProcessing: {
    id: 'app.containers.Integrations.addCandidateToTearsheetProcessing',
    defaultMessage:
      'Candidates are being added to the selected tearsheets. This may take a few minutes to complete.',
  },
  createTearsheetSuccess: {
    id: 'app.containers.Integrations.createTearsheetSuccess',
    defaultMessage: 'Tearsheet was successfully created',
  },
  createTearsheetError: {
    id: 'app.containers.Integrations.createTearsheetError',
    defaultMessage: 'Could not create tearsheet. Please try again.',
  },
  jdPromptTitle: {
    id: 'app.containers.Integrations.jdPromptTitle',
    defaultMessage: 'Which description should we search on?',
  },
  jdPromptIntro: {
    id: 'app.containers.Integrations.jdPromptIntro',
    defaultMessage:
      '{job} has more than one description. Pick the one that holds the real spec.',
  },
  jdPromptIntroUnknown: {
    id: 'app.containers.Integrations.jdPromptIntroUnknown',
    defaultMessage:
      "We couldn't read this job's descriptions. Pick the one the search should use.",
  },
  jdPromptInternal: {
    id: 'app.containers.Integrations.jdPromptInternal',
    defaultMessage: 'Job Description',
  },
  jdPromptInternalHint: {
    id: 'app.containers.Integrations.jdPromptInternalHint',
    defaultMessage: 'The internal spec, as written in Bullhorn.',
  },
  jdPromptPublic: {
    id: 'app.containers.Integrations.jdPromptPublic',
    defaultMessage: 'Published Description',
  },
  jdPromptPublicHint: {
    id: 'app.containers.Integrations.jdPromptPublicHint',
    defaultMessage: 'The version published to your careers site.',
  },
  jdPromptBoth: {
    id: 'app.containers.Integrations.jdPromptBoth',
    defaultMessage: 'Both descriptions',
  },
  jdPromptBothHint: {
    id: 'app.containers.Integrations.jdPromptBothHint',
    defaultMessage: 'Both fields, combined into one document.',
  },
  jdPromptRemember: {
    id: 'app.containers.Integrations.jdPromptRemember',
    defaultMessage: 'Use this for every search from now on',
  },
  jobPrefillError: {
    id: 'app.containers.Integrations.jobPrefillError',
    defaultMessage: 'Could not load this Bullhorn job. Please try again.',
  },
});
